import { HStack, Spacer, XButton, XImage } from "IZOX/_X";
import { GState } from "IZOX/STATIC";
import LoginBtn from "./LoginBtn";
import { observer } from "mobx-react";

function HeaderM({
  history,
  _closeReg,
  _toPage
}){

  return (
    <HStack height={70} pH={20} shadow flexShrink={0} zIndex={500}>
      <XButton onPress={() => {
        _toPage("/Home");
      }}>
        <XImage source="/Images/mutualins-logo-latest.png" width={151}/>
      </XButton>
      <Spacer/>
      <HStack spacing={10} fitWidthToContent>
        <LoginBtn _closeReg={_closeReg} history={history}/>
        <XButton onPress={() => GState.setMini(!GState.mini)}>
          {!GState.mini ?
            <XImage source="/Images/Icons/menu.png" noResize width={32} height={32}/>
            : <XImage source="/Images/Icons/menuclose.png" noResize width={32} height={32}/>}
        </XButton>
      </HStack>
    </HStack>
  );

}

export default observer(HeaderM);